import DealerCart from 'components/admin/Carts/DealerCart/DealerCart'
import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Segment } from 'semantic-ui-react'
import DealerCartHeader from './DealerCartHeader'

const mapStateToProps = (state, ownProps) => {
  const { dealerOrders = {} } = state.carts
  const { users = [] } = state.userAdmin
  const {
    match: {
      params: { cart_id },
    },
  } = ownProps
  return { dealerOrders, users, cart_id: Number(cart_id) }
}

const mapDispatchToProps = undefined

class DealerCartDetails extends React.Component {
  printCart = () => window.print()

  actions() {
    return [
      {
        icon: 'print',
        color: 'grey',
        content: I18n.t('admin.carts.details.print'),
        onClick: (event) => {
          event.preventDefault()
          this.printCart()
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    // props
    const { dealerOrders, users, cart_id } = this.props

    const cart =
      (dealerOrders.carts || []).find((cart) => cart.id === cart_id) || {}
    const { data = {} } = cart
    const { address = {} } = data

    address.address1 = address.address_1
    address.address2 = address.address_2
    address.address3 = address.address_3

    if (!cart.id) return <ComponentPlaceholder inactive loading={false} />

    const user =
      users.find((user) =>
        cart.data.original_user_id
          ? user.id === cart.data.original_user_id
          : user.id === cart.user_id
      ) || {}

    return (
      <div className={classNames(['cartDetails', dark && 'inverted'])}>
        <ComponentHeader
          title={I18n.t(`admin.carts.details.title_dealer_order`, {
            customerName: user.address1,
            cartDate: new Date(cart.created_at).toLocaleDateString(
              'de-CH',
              config.format.date
            ),
          })}
          actions={this.actions()}
        />

        <Segment attached className={classNames([dark && 'inverted'])}>
          <DealerCartHeader {...data} user={user}/>
        </Segment>

        <Segment
          attached
          className={classNames(['payload', dark && 'inverted'])}>
          <DealerCart cart={cart} />
        </Segment>
      </div>
    )
  }
}

DealerCartDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(DealerCartDetails)
export default withRouter(DealerCartDetails)



// WEBPACK FOOTER //
// ./src/components/admin/Carts/DealerCart/DealerCartDetails.jsx